import {
  createAsyncThunk,
} from '@reduxjs/toolkit';

import type { ThunkApiType } from '@/store';
import type { SheetJson } from '@/types/domain/attendance/entities/sheetEntity';

import { attendRegisterSlice } from '@/domain/attendRegister/redux';
import * as applicationAttendance from '@/domain/attendance/service/application';
import { service } from '@/share';

export const getAttendRegisterList = createAsyncThunk<
  void,
  void,
  ThunkApiType
>(
  'attendRegister/getAttendRegisterList',
  async (_, thunkApi) => {
    const { childList } = thunkApi.getState().child;
    const { year, month } = thunkApi.getState().attendRegister;
    const promises = childList.map((v) => service.attendRegister.getAttendRegisterMonthList(
      year,
      month,
      `${v.parentId}_${v.childId}`,
      null,
    ));
    const results = await Promise.all(promises);
    const items = [];
    for (let i = 0; i < results.length; i += 1) {
      for (let j = 0; j < results[i].length; j += 1) {
        items.push(results[i][j]);
      }
    }
    thunkApi.dispatch(attendRegisterSlice.actions.setAttendRegisterList({
      items,
      nextToken: '',
    }));
  },
);

export const getSheetList = createAsyncThunk<
  SheetJson[],
  void,
  ThunkApiType
>(
  'attendRegister/getSheetList',
  async (_, thunkApi) => {
    const { childList } = thunkApi.getState().child;
    const { year, month } = thunkApi.getState().attendRegister;
    const promises = childList.map((v) => applicationAttendance.getSheetMonthList(
      year,
      month,
      `${v.parentId}_${v.childId}`,
      null,
    ));
    const results = await Promise.all(promises);
    const items = [];
    for (let i = 0; i < results.length; i += 1) {
      for (let j = 0; j < results[i].length; j += 1) {
        items.push(results[i][j]);
      }
    }
    return items;
  },
);
